export const paymentMethod = {
	title: "Modifier votre moyen de paiment",
	default: "Par défaut",
	expired: "Expiré",
	'update-payment': {
		title: "Cliquez ici pour modifier votre moyen de paiement",
		label: "modifier",
		failed:"Le lien de mise à jour de votre moyen de paiement n’est pas disponible pour le moment. Merci de réessayer un peu plus tard."
	},
	demo: {
		text: "{0} C’est une version de démo, on paye pas ici 😉"
	},
	'no-license': {
		text1: "{0} Aucune carte de paiement n’est actuellement enregistrée. Pour activer votre compte et accéder à l’ensemble des fonctionnalités, merci de souscrire à un abonnement en cliquant {1}.",
		text2: "ici",
		title: "Cliquez ici pour vous abonner"
	}
}
